import React, { Component } from 'react';
import '../css/Universum.css';
import Logo from '../Images/Logo.png';
import Background from '../Images/Background.jpg';
import Login from '../Images/Login.png';


export class UniversumLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Usuario: "",
            Contrasenia: ""
        };

        this.cambioUsuario = this.cambioUsuario.bind(this);
        this.cambioPass = this.cambioPass.bind(this);
        this.enviar = this.enviar.bind(this);
    }

    cambioUsuario(event) {
        this.setState({ Usuario: event.target.value });
    }

    cambioPass(event) {
        this.setState({ Contrasenia: event.target.value });
    }

    enviar() {
        var xhr = new XMLHttpRequest();
        var principal = this;
        var sobre = { Usuario: this.state.Usuario, Contrasenia: this.state.Contrasenia };

        xhr.open("POST", "ead/Universum/Login", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onload = function () {
            if (xhr.status === 200) {
                if (xhr.responseText == "OK") {
                    principal.props.reportarLogin()
                } else {
                    alert(xhr.responseText);

                }

            } else {
                alert(xhr.responseText);
            }


        };

        xhr.send(JSON.stringify(sobre));
    }

    render() {
        return (
            <div>
                <img src={Logo} alt="ICYTEG" class="LogoFlotante" />

                <img src={Background} alt="Imagen de fondo" class="ImagenCentral" />
                <div class="LoginArea">
                    <img src={Login} alt="Login" class="LogImg" />
                    <div class="EnLinea" >
                        <div class="PasarelaLogin" >

                        </div>


                        <input type="text" name="TxtUsuario" id="TxtUsuario" runat="server" value={this.state.Usuario} class="TxtAzul" placeholder="Usuario" onChange={this.cambioUsuario} /><br /><br />
                        <input type="password" name="TxtPassword" id="TxtPassword" runat="server" value={this.state.Contrasenia} class="TxtAzul" placeholder="Contraseña" onChange={this.cambioPass} /><br /><br /><br />
                        <input type='button' class="boton1" value="Ingresar" onClick={this.enviar} />
        
                    </div>
                </div>
            </div>
        )
    }
}
export default UniversumLogin;


// WEBPACK FOOTER //
// ./src/components/UniversumLogin.js